"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSdkContext = exports.SdPlatformAccessTokenState = void 0;
/**
 * Status of the access token
 */
var SdPlatformAccessTokenState;
(function (SdPlatformAccessTokenState) {
    /** no access token has been set */
    SdPlatformAccessTokenState[SdPlatformAccessTokenState["NoToken"] = 0] = "NoToken";
    /** the access token has expired */
    SdPlatformAccessTokenState[SdPlatformAccessTokenState["Expired"] = 1] = "Expired";
    /** the access token has been set and is not expired yet */
    SdPlatformAccessTokenState[SdPlatformAccessTokenState["Valid"] = 2] = "Valid";
})(SdPlatformAccessTokenState = exports.SdPlatformAccessTokenState || (exports.SdPlatformAccessTokenState = {}));
/**
 * Contextual information shared between the authentication API
 * and the ShapeDiver Platform resource APIs.
 */
class SdPlatformSdkContext {
    constructor(__api, __config) {
        this.__api = __api;
        this.__config = __config;
        this.__accessTokenDetails = {};
    }
    cloneTokenDetails(details) {
        var _a;
        return {
            access_token: details.access_token ? details.access_token + '' : undefined,
            refresh_token: details.refresh_token ? details.refresh_token + '' : undefined,
            expires_in: details.expires_in ? details.expires_in : undefined,
            token_type: details.token_type ? details.token_type : undefined,
            user_id: details.user_id ? details.user_id : undefined,
            expirationDate: details.expirationDate ? new Date((_a = details.expirationDate) === null || _a === void 0 ? void 0 : _a.getTime()) : undefined
        };
    }
    /**
     * Get details of the access token
     */
    get accessTokenDetails() {
        return this.cloneTokenDetails(this.__accessTokenDetails);
    }
    /**
     * Set details of the access token
     * @param details
     */
    setAccessTokenDetails(details) {
        this.__accessTokenDetails = this.cloneTokenDetails(details);
    }
    /**
     * Base API.
     */
    get api() {
        return this.__api;
    }
    /**
     * SDK Configuration.
     */
    get config() {
        return this.__config;
    }
    /**
     * Status of the access token.
     */
    get accessTokenState() {
        const accessToken = this.__accessTokenDetails.access_token;
        if (!accessToken) {
            return SdPlatformAccessTokenState.NoToken;
        }
        const date = this.__accessTokenDetails.expirationDate;
        if (!date || new Date() > date) {
            return SdPlatformAccessTokenState.Expired;
        }
        return SdPlatformAccessTokenState.Valid;
    }
    /**
     * Status of authentication.
     */
    get authData() {
        return {
            accessTokenState: this.accessTokenState,
            isAuthenticated: !!this.accessTokenDetails.access_token,
            userId: this.accessTokenDetails.user_id ? this.accessTokenDetails.user_id + '' : null,
        };
    }
}
exports.SdPlatformSdkContext = SdPlatformSdkContext;
//# sourceMappingURL=SdPlatformSdkContext.js.map